import { SelectAutocompleteOption } from './SelectAutocomplete';

export function toSelectAutocompleteOptions(strs: string[]): SelectAutocompleteOption[] {
  return strs.map((str: string) => ({ value: str, label: str }));
}
